export function getRem(num) {
  return `${num / 100}rem`;
}

export function download(url) {
  const a = document.createElement('a');
  a.href = url;
  a.download = '';
  a.click();
}

export function requestAnimFrame() {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
}

function inWindow(rect) {
  if (rect.left > 0 && rect.right < window.innerWidth && rect.top > 0 && rect.bottom < window.innerHeight) {
    return true;
  } else {
    return false;
  }
}

function animate1(dom) {
  let deg = null;
  const random = Math.floor(Math.random() * 3);
  if (random === 0) {
    deg = -90;
  }
  if (random === 1) {
    deg = -45;
  }
  if (random === 2) {
    deg = -225;
  }

  dom.setAttribute('isAnimation', '1');
  const r = Number(dom.getAttribute('r'));
  const g = Number(dom.getAttribute('g'));
  const b = Number(dom.getAttribute('b'));

  let startTime;
  const duration = 1000;
  let point = 85; //临界点
  const step = (timestamp) => {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const percent = Math.min(100 * elapsed / duration, 100);
    let style = '';
    if (percent < point) {
      style = `background: linear-gradient(${deg}deg,
        rgba(${r}, ${g}, ${b}, 1) 0%,
        rgba(${r}, ${g}, ${b}, 1) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, 1) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, 0) 100%);`
    } else {
      const opacity = 1 - (percent - point) / (100 - point);
      style = `background: linear-gradient(-90deg,
        rgba(${r}, ${g}, ${b}, ${opacity}) 0%,
        rgba(${r}, ${g}, ${b}, ${opacity}) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, ${opacity}) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, 0) 100%);`
    }
    dom.setAttribute('style', style);

    if (elapsed < duration) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

function animate2(dom) {
  dom.setAttribute('isAnimation', '1');
  const r = Number(dom.getAttribute('r'));
  const g = Number(dom.getAttribute('g'));
  const b = Number(dom.getAttribute('b'));

  let startTime;
  const duration = 618;
  let point = 85; //临界点
  const step = (timestamp) => {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const percent = Math.min(100 * elapsed / duration, 100);
    let style = '';
    let parentStyle = `transform: translateY(-${50 * (100 - percent) / 100}px);`;
    // dom.parentNode.style = parentStyle;
    dom.parentNode.setAttribute('style', parentStyle);
    if (percent < point) {
      style = `background: linear-gradient(0deg,
        rgba(${r}, ${g}, ${b}, 1) 0%,
        rgba(${r}, ${g}, ${b}, 1) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, 1) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, 0) 100%);
        `
    } else {
      const opacity = 1 - (percent - point) / (100 - point);
      style = `background: linear-gradient(0deg,
        rgba(${r}, ${g}, ${b}, ${opacity}) 0%,
        rgba(${r}, ${g}, ${b}, ${opacity}) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, ${opacity}) ${100 - percent}%,
        rgba(${r}, ${g}, ${b}, 0) 100%);
        `
    }
    dom.setAttribute('style', style);

    if (elapsed < duration) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

export function animationDom() {
  const doms1 = document.querySelectorAll('.animate1');
  doms1.forEach(dom => {
    const isAnimation = dom.getAttribute('isAnimation');

    if (inWindow(dom.getBoundingClientRect()) && isAnimation !== '1') {
      animate1(dom);
    }
  });

  const doms2 = document.querySelectorAll('.animate2');
  doms2.forEach(dom => {
    const isAnimation = dom.getAttribute('isAnimation');

    if (inWindow(dom.getBoundingClientRect()) && isAnimation !== '1') {
      animate2(dom);
    }
  });
}

export const SCROLL_DELTA = 150;